import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';

@Component({
    selector: 'app-add-bad-debt-withdrawal',
    templateUrl: './add-bad-debt-withdrawal.component.html',
    styleUrls: ['./add-bad-debt-withdrawal.component.scss'],
    standalone: false
})
export class AddBadDebtWithdrawalComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  companyBankAccountList: Account[] = [];
  cashAccountList: Account[] = [];
  @Output() passEntry = new EventEmitter<any>();
  selectedAccountId: number;
  selectedAccountBalance: number;

  @Input() profileId: number;
  @Input() maxAmount: number;
  //2-WAY BINDING INFO
  withdrawalDate: Date;
  remark: string;
  amount = 0;
  disabledSubmit = false;

  ngOnInit(): void {
    this.withdrawalDate = new Date();

    const loggedInCompany = Number(sessionStorage.getItem('companyId'));
    this.getAllAccountsOfCompany(loggedInCompany);
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  isFieldNull() {
    const paymentNull = (this.amount == undefined || this.amount == 0);
    const remarkNull = (this.remark == undefined || this.remark == "");
    const selectedAccountIdNull = (this.selectedAccountId == undefined);
    const paymentValid = isNaN(+this.amount)

    return paymentNull || remarkNull || selectedAccountIdNull || paymentValid
  }

  private getAllAccountsOfCompany(companyId: number) {
    const xhttp = this.restapi.getRequest(this.constructApi.getAccountsOfCompany(companyId));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const amount = (json.balance == undefined) ? 0 : json.balance;
          const account = new Account(json.id, json.number, json.name, json.holderName, amount, json.companyId, json.username);

          if (account.Username != undefined)
            this.cashAccountList.push(account)
          else {
            this.companyBankAccountList.push(account);
          }
        });
      }
    };
  }

  withdrawSimpanBD() {
    this.disabledSubmit = true;
    const isoTaskDate = (new Date(Number(this.withdrawalDate))).toISOString();

    const data = {
      "amount": this.amount,
      "accountId": Number(this.selectedAccountId),
      "date": isoTaskDate,
      "remark": "Simpan BD Withdrawal - " + this.remark
    };

    const xhr = this.restapi.postRequest(this.constructApi.getWithdrawBadDebtsToSimpan(this.profileId), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          this.disabledSubmit = false;

          this.passEntry.emit()
          this.reset();
          this.sharedService.openAlert("Successfully withdraw simpan BD!", ALERT_TYPE.SUCCESS);
        } else {
          this.disabledSubmit = false;
          this.sharedService.openErrorMessage(xhr);
        }
      }
    }
  }

  isBalanceInsufficient(balance: number) {
    // this.sharedService.openAlert(balance);
    if (balance > this.amount)
      return false;
    else
      return true;
  }

  confirmBeforePayBD() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "You are withdrawing simpan BD of RM " + this.amount + " to simpan, are you sure?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.withdrawSimpanBD();
    });
  }

  submit() {
    if (this.isFieldNull()) {
      this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER)
    }
    else if (this.amount > this.maxAmount) {
      this.sharedService.openAlert('You can only withdraw maximum of RM ' + this.maxAmount + "!", ALERT_TYPE.DANGER);
    }
    else {
      this.confirmBeforePayBD();
    }
  }

  reset() {
    this.activeModal.close();
  }
}
